import transpose from "./transpose";

export default function() {
  return transpose(arguments);
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-array/src/zip.js
// module id = 1331
// module chunks = 0